export default __webpack_public_path__ + "static/media/ai.2b576a4c.png";